import { gql } from '@apollo/client';
export const getUploadUrlMutation = gql `
  mutation GetUploadUrl($record: GetUploadUrlRecord!) {
    getUploadUrl(record: $record)
  }
`;
//# sourceMappingURL=getUploadUrl.js.map